export default {
  'menu.login': '登录',
  'menu.home': '首页',
  'menu.welcome': '欢迎',
  'menu.system': '系统管理',
  'menu.system.user': '用户管理',
  'menu.system.role': '角色管理',
  'menu.system.menu': '菜单管理',
  'menu.system.dept': '部门管理',
  'menu.account': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.help': '帮助中心',
  'menu.logout': '退出登录',
  'menu.log': '日志系统',
  'menu.log.login': '登录日志',
  'menu.log.operate': '操作日志',
  'menu.bd': 'BD管理',
  'menu.bd.user': '人员管理',
  'menu.bd.permissions': '邀请链路',
  'menu.invitationLink': '链路管理',
  'menu.team': '团队管理',
  'menu.teamViewInviteChain': '查看邀请链路',
  'menu.tradingVolume': '团队交易量',
  'menu.futures': '合约合伙人',
  'menu.futures.rebate': '返佣配置',
  'menu.futures.team': '团队管理',
  'menu.futures.viewInviteChain': '查看邀请链路',
  'menu.futures.tradingVolume': '团队交易量',
  'menu.futures.teamCommission': '团队佣金',
  'menu.futures.commissionSummary': '返佣汇总',
  'menu.futures.commissionDetails': '返佣明细',
  'menu.futures.myCommission': '我的佣金',
  'menu.futures.subordinatePosition': '下级持仓',
  'menu.spot': '现货合伙人',
  'menu.spot.rebate': '返佣配置',
  'menu.spot.team': '团队管理',
  'menu.spot.viewInviteChain': '查看邀请链路',
  'menu.spot.tradingVolume': '团队交易量',
  'menu.spot.teamCommission': '团队佣金',
  'menu.spot.myCommission': '我的佣金',
  'menu.fundRecords': '资金记录',
  'menu.fundRecords.rechargeRecord': '充值记录',
  'menu.fundRecords.withdrawRecord': '提现记录',
  'menu.fundRecords.transferRecord': '划转记录',
  'menu.dashboardFutures': '合约看板',
  'menu.dashboardSpot': '现货看板',
  'menu.dashboard': '数据总览',
  'menu.activityData': '活动数据',
};
